import { useIsAnythingBeingMapped } from "routes/asset-register/plugins/asset-mapping/use-is-anything-being-mapped"
import { useIsAnythingRefining } from "routes/asset-register/plugins/asset-mapping/use-is-anything-refining"
import { alert } from "lib/@dialogs/alert"

export function useRegisterProcessingGuard() {
    const isMapping = useIsAnythingBeingMapped()
    const isRefining = useIsAnythingRefining()
    const isBlocked = isMapping || isRefining

    return { isBlocked, showBlockedAlert }

    function showBlockedAlert() {
        return alert(
            "This register is currently being processed by Mobiliser and cannot be updated until processing is complete.",
            "Register Processing"
        )
    }
}
